import CockpitNotificationDifferenceModelBase from '../_generated/modelBases/cockpit-notification-difference-model-base';

export default class CockpitNotificationDifferenceModel extends CockpitNotificationDifferenceModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
